<script lang="ts">
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import Button, { Label } from '@smui/button';
	import Textfield from '@smui/textfield';
	import { mdiGoogle, mdiContentSave, mdiLogin } from '@mdi/js';
	import auth from '#stores/authStore';
	import CenteredPaper from '#lib/CenteredPaper.svelte';
	import SvgIcon from '#lib/SvgIcon.svelte';
	import Paper, { Content } from '@smui/paper';

	async function doGoogleSignup() {
		const success = await auth.loginWithGoogle(placeId);
		if (success) await redirectToApp();
	}
	async function doEmailSignup() {
		if (name && email && password) {
			const newUser = await auth.signUpWithEmail(name, email, password, placeId);
			if (newUser) {
				await redirectToApp();
			}
		}
	}
	async function redirectToApp() {
		await auth.waitForFirebase();
		window.location.href = '/app';
	}
	interface Props {
		name: string;
		email: string;
		password: string;
	}

	let { name = '', email = '', password = '' }: Props = $props();

	let placeId: string | null;

	if ($auth.isLoggedIn) {
		auth.logout();
	}
	let errorMessageSanitized = $derived(
		$auth.errorMessage?.slice('Firebase: Error (auth/'.length).slice(0, -2).replaceAll('-', ' ')
	);

	onMount(async () => {
		placeId = new URLSearchParams(window.location.search).get('key');
	});
</script>

<CenteredPaper title="Sign up">
	<Button variant="raised" style="margin: 10px 0; width: 100%" onclick={doGoogleSignup}>
		<SvgIcon mdiIcon={mdiGoogle} />
		<Label>&nbsp;Sign Up with Google</Label>
	</Button>

	<Paper color="primary" variant="outlined" style="width:100%">
		<div class="small-title">Sign up with Email</div>
		<form name="signup" method="dialog">
			<Content>
				<div class="signup-form" in:fade|global>
					<Textfield
						label="Name"
						input$name="name"
						style="width: 100%"
						helperLine$style="width: 100%;"
						class="outlined"
						variant="outlined"
						bind:value={name}
						input$autocomplete="name" />
					<Textfield
						label="Email"
						input$name="email"
						style="width: 100%"
						helperLine$style="width: 100%;"
						class="outlined"
						variant="outlined"
						bind:value={email}
						input$autocomplete="email" />
					<Textfield
						label="Password (7 characters minimum)"
						input$name="password"
						style="width: 100%;"
						helperLine$style="width: 100%;"
						class="outlined"
						variant="outlined"
						type="password"
						bind:value={password}
						input$autocomplete="new-password" />
					{#if $auth.errorOccurred}
						<div class="error-message">Error: {errorMessageSanitized}</div>
					{/if}
					<div class="submit-buttons">
						<Button
							variant="raised"
							style="margin: 10px 0; "
							class="signup-button"
							onclick={doEmailSignup}
							disabled={!name || !email || !password || password.length < 7}>
							<SvgIcon mdiIcon={mdiContentSave} />
							<Label>Submit</Label>
						</Button>
					</div>
				</div>
			</Content>
		</form>
	</Paper>
	<Button
		variant="raised"
		color="secondary"
		style="margin: 10px 0; width: 100%"
		onclick={() => (window.location.href = '/login')}>
		<SvgIcon mdiIcon={mdiLogin} />
		<Label>&nbsp;Login with an existing account</Label>
	</Button>
</CenteredPaper>

<style>
	.small-title {
		text-align: center;
		font-size: 1.1rem;
		padding-bottom: 10px;
	}
	.signup-form {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 10px;
	}
	.submit-buttons {
		display: flex;
		flex-direction: row;
		width: 100%;
		justify-content: space-between;
		gap: 16px;
	}
	.error-message {
		text-align: center;
		color: darkred;
	}
</style>
